import { combineReducers } from '@reduxjs/toolkit';

import { permissionsSlice } from './permissions';

export const permissionsReducers = combineReducers({
  permissions: permissionsSlice.reducer,
});
